import React from 'react';

const FilterLinesIcon = () => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 7H16M1 1H19M7 13H13" stroke="#212121" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default FilterLinesIcon;
